import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TimeDisplay } from 'shared/time-display-service/time-display.service';

export interface DatePipeOptions {
    format?: string;
    time?: TimeDisplay;
    showUtcTimeLabel?: boolean;
    ago?: boolean;
}

// TODO: Moment.js is deprecated. Replace with another library when possible.
@Pipe({
    name: 'adjustUtcDate',
})
export class AdjustUtcDatePipe implements PipeTransform {
    transform(value: string | number | Date, options: DatePipeOptions = {}): any {
        if (value == null) {
            return '';
        }

        const format = options.format || 'YYYY-MM-DD HH:mm:ss.SSS';

        const date = moment.utc(value);

        if (!date.isValid()) {
            return value;
        }

        if (options.time.utcTimezoneInHours) {
            date.utcOffset(options.time.utcTimezoneInHours);
        }

        if (options.ago) {
            return `${date.fromNow()}`;
        }

        const dateStr = `${date.format(format)}${options.showUtcTimeLabel ? ` ${options.time.utcLabel}` : ''}`;

        return dateStr;
    }
}
